import LogoIcon from '../../assets/icons/logo.svg?react';
import MetroIconLogo from '../../assets/icons/icon-logo.svg?react';
import facebookIcon from '../../assets/icons/facebook.png';
import xIcon from '../../assets/icons/x.png';
import insIcon from '../../assets/icons/ins.png';

import SocialLink from './SocialLink';
import Locale from './Locale';
import styles from './header.module.css';

const SOCIAL_LINKS = [
  {
    id: 'facebook',
    href: 'https://www.facebook.com/people/%E6%9D%B1%E4%BA%AC%E3%83%A1%E3%83%88%E3%83%ADFind-my-Tokyo/100069630901810/#',
    icon: (
      <img src={facebookIcon} alt="Facebook" className={styles.socialIcon} />
    )
  },
  {
    id: 'x',
    href: 'https://x.com/tokyometro_info',
    icon: <img src={xIcon} alt="X" className={styles.socialIcon} />
  },
  {
    id: 'instagram',
    href: 'https://www.instagram.com/tokyometro_official/#',
    icon: <img src={insIcon} alt="Instagram" className={styles.socialIcon} />
  }
];

const Header = ({
  showLocale = true,
  showMetroIcon = false
}: {
  showLocale?: boolean;
  showMetroIcon?: boolean;
}) => {
  return (
    <div className={styles.header}>
      {showMetroIcon ? (
        <MetroIconLogo className={styles.logo} />
      ) : (
        <LogoIcon className={styles.logo} />
      )}

      <div className={styles.link}>
        {SOCIAL_LINKS.map(({ id, href, icon }) => (
          <SocialLink key={id} href={href} icon={icon} />
        ))}
        {showLocale && <Locale />}
      </div>
    </div>
  );
};

export default Header;
